export default {
  "content": "<path fill=\"#4E4EDA\" d=\"M3.86 11.25c-.27 0-.54-.11-.72-.31l-2.86-3a.996.996 0 111.44-1.38l2.07 2.17L10.07.88c.34-.43.97-.5 1.41-.16.43.34.5.97.16 1.41l-6.99 8.75c-.18.23-.45.36-.74.38-.02-.01-.04-.01-.05-.01\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "12",
    "height": "12",
    "fill": "none"
  }
};